module.exports = __webpack_public_path__ + "static/media/profilebg.21e2216ddbd680cc64dc.29435702.png";